import script from "./HeaderLacenAmostras.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderLacenAmostras.vue?vue&type=script&setup=true&lang=js"

import "./HeaderLacenAmostras.vue?vue&type=style&index=0&id=65dfa902&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65dfa902"]])

export default __exports__